import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelFilter } from "@website/accommodation-ui/hotel-filter";
import { HotelListHeader } from "@website/accommodation-ui/hotel-list-header";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { HotelPagination } from "@website/accommodation-ui/hotel-pagination";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { HotelUpdateSearchModal } from "@website/accommodation-ui/hotel-update-search-modal";
import { ListingContainer } from "@website/accommodation-ui/listing-container";
import { SchemaVillaListPage } from "@website/accommodation-ui/scripts";
import { VillaMeta } from "@website/accommodation-ui/villa-meta";
import { VillaSearch } from "@website/accommodation-ui/villa-search";
import { useIsVisible } from "@website/hooks/is-visible";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { Switch } from "@website/ui/switch";
import { isChannel } from "@website/utils/channel/helpers";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { BannerSlide } from "@website/widget/banner-slide";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { AnimatedButton } from "@website/widget/search-map/animatedButton";
import { SeoComponents } from "@website/widget/seo-components";
import { Telesales } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import omit from "lodash-es/omit";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { useState, useSyncExternalStore } from "react";
import Custom404 from "../../[...gone].page";
import { useCityPage } from "./index.hook";
import { CityPagePropertiesType } from "./index.types";
const stripCollapseObserverOptions = {
  rootMargin: "120px 0px 0px 0px",
  threshold: 0
};
const stripExpandObserverOptions = {
  rootMargin: "24px 0px 0px 0px",
  threshold: 0
};
type StableStripTriggerState = {
  collapseTriggerInView: boolean;
  expandTriggerInView: boolean;
  stripTriggerInView: boolean;
};
const subscribeToClientRender = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;
const getNextStripTriggerInView = (current: boolean, collapseTriggerInView: boolean, expandTriggerInView: boolean) => {
  if (current && !collapseTriggerInView) return false;
  if (!current && expandTriggerInView) return true;
  return current;
};
const useStableStripTrigger = (collapseTriggerInView, expandTriggerInView) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== collapseTriggerInView || $[1] !== expandTriggerInView) {
    t0 = {
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView: true
    };
    $[0] = collapseTriggerInView;
    $[1] = expandTriggerInView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [state, setState] = useState(t0);
  if (state.collapseTriggerInView !== collapseTriggerInView || state.expandTriggerInView !== expandTriggerInView) {
    let t1;
    if ($[3] !== collapseTriggerInView || $[4] !== expandTriggerInView || $[5] !== state.stripTriggerInView) {
      t1 = getNextStripTriggerInView(state.stripTriggerInView, collapseTriggerInView, expandTriggerInView);
      $[3] = collapseTriggerInView;
      $[4] = expandTriggerInView;
      $[5] = state.stripTriggerInView;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const stripTriggerInView = t1;
    setState({
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView
    });
    return stripTriggerInView;
  }
  return state.stripTriggerInView;
};
const CityPageContent: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(139);
  const router = useRouter();
  const {
    hasMap,
    isNewPlP,
    onMapClick,
    modalProps,
    headerProps,
    searchProperties,
    bannersProperties,
    telesaleProperties,
    hotelPaginationProps,
    hotelListHeaderProps,
    citiesFilterProperties,
    hotelBreadcrumbsProperties,
    hotelCitiesMainContentProps,
    listingContainerProps
  } = useCityPage(properties);
  const zinStoryTag = `${router?.query?.locationType}/${router?.query?.cityTitle}`;
  const {
    reference: stripCollapseTriggerReference,
    inView: stripCollapseTriggerInView
  } = useIsVisible(stripCollapseObserverOptions, true);
  const {
    reference: stripExpandTriggerReference,
    inView: stripExpandTriggerInView
  } = useIsVisible(stripExpandObserverOptions, true);
  const stripTriggerInView = useStableStripTrigger(stripCollapseTriggerInView, stripExpandTriggerInView);
  const t0 = properties?.seoData?.title;
  const t1 = properties?.seoData?.description;
  const t2 = properties.locationData?.type;
  const t3 = properties.locationData?.title;
  let t4;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <VillaMeta title={t0} description={t1} locationType={t2} locationTitle={t3} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `/${properties.locationData?.type}/${properties.locationData?.url}`;
  const t6 = properties?.seoData?.title;
  const t7 = properties?.seoData?.description;
  const t8 = properties.locationData?.title;
  let t9;
  if ($[5] !== hotelCitiesMainContentProps.hotelList || $[6] !== router.locale || $[7] !== router.query.date_from || $[8] !== router.query.date_to || $[9] !== router.query.room_capacity || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <SchemaVillaListPage villas={hotelCitiesMainContentProps.hotelList} path={t5} locale={router.locale} name={t6} description={t7} locationTitle={t8} dateFrom={router.query.date_from} dateTo={router.query.date_to} roomCapacity={router.query.room_capacity} />;
    $[5] = hotelCitiesMainContentProps.hotelList;
    $[6] = router.locale;
    $[7] = router.query.date_from;
    $[8] = router.query.date_to;
    $[9] = router.query.room_capacity;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== stripCollapseTriggerReference) {
    t10 = <div className="absolute inset-x-0 top-0 h-px" ref={stripCollapseTriggerReference} />;
    $[15] = stripCollapseTriggerReference;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== stripExpandTriggerReference) {
    t11 = <div className="absolute inset-x-0 top-0 h-px" ref={stripExpandTriggerReference} />;
    $[17] = stripExpandTriggerReference;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div aria-hidden={true} className="pointer-events-none relative h-0 w-full">{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== modalProps) {
    t13 = <HotelUpdateSearchModal {...modalProps} />;
    $[22] = modalProps;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== headerProps) {
    t14 = <Header {...headerProps} />;
    $[24] = headerProps;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="bg-outline-thin h-px w-full" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = `sticky top-0 bg-white ${searchProperties.isSearchPanelOpen ? "z-20" : "z-10 md:z-20"}`;
  let t17;
  if ($[27] !== isNewPlP || $[28] !== searchProperties) {
    t17 = <VillaSearch {...searchProperties} disableSticky={true} isNewPlP={isNewPlP} />;
    $[27] = isNewPlP;
    $[28] = searchProperties;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== hasMap || $[31] !== hotelListHeaderProps || $[32] !== isNewPlP || $[33] !== onMapClick || $[34] !== stripTriggerInView) {
    t18 = isNewPlP && <HotelListHeader {...hotelListHeaderProps} isSticky={isNewPlP} isStickyPositioned={false} stripTriggerInView={stripTriggerInView} hasMap={hasMap} onMapClick={onMapClick} />;
    $[30] = hasMap;
    $[31] = hotelListHeaderProps;
    $[32] = isNewPlP;
    $[33] = onMapClick;
    $[34] = stripTriggerInView;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t18) {
    t19 = <div className={t16}>{t17}{t18}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== hasMap || $[41] !== isNewPlP || $[42] !== onMapClick) {
    t20 = isNewPlP && hasMap && onMapClick && <div className="lg:hidden"><AnimatedButton isNewPlP={true} className="bottom-6" icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} /></div>;
    $[40] = hasMap;
    $[41] = isNewPlP;
    $[42] = onMapClick;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = `flex flex-col gap-5 ${isNewPlP ? "px-4" : "px-6"} lg:px-6 lg:py-5 xl:mx-auto xl:max-w-[1200px] xl:px-0`;
  let t22;
  if ($[44] !== hotelBreadcrumbsProperties || $[45] !== isNewPlP) {
    t22 = !isNewPlP && <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} /></div>;
    $[44] = hotelBreadcrumbsProperties;
    $[45] = isNewPlP;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const t23 = `${isNewPlP ? "lg:flex" : ""} hidden flex-row items-center justify-between`;
  let t24;
  if ($[47] !== hotelListHeaderProps.city || $[48] !== hotelListHeaderProps.hasCityPrefix || $[49] !== hotelListHeaderProps.loading || $[50] !== hotelListHeaderProps.totalItem || $[51] !== isNewPlP) {
    t24 = isNewPlP && <div className="lg:mt-0"><HotelCityTitle isNewPlP={isNewPlP} city={hotelListHeaderProps?.city} hasCityPrefix={hotelListHeaderProps?.hasCityPrefix} loading={hotelListHeaderProps?.loading} totalItem={hotelListHeaderProps?.totalItem} /></div>;
    $[47] = hotelListHeaderProps.city;
    $[48] = hotelListHeaderProps.hasCityPrefix;
    $[49] = hotelListHeaderProps.loading;
    $[50] = hotelListHeaderProps.totalItem;
    $[51] = isNewPlP;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== hotelBreadcrumbsProperties) {
    t25 = <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} className="hidden lg:flex" /></div>;
    $[53] = hotelBreadcrumbsProperties;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t24 || $[56] !== t25) {
    t26 = <div className="flex flex-col gap-1">{t24}{t25}</div>;
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== hotelListHeaderProps.sortProperties || $[59] !== isNewPlP) {
    t27 = <HotelSortView {...hotelListHeaderProps.sortProperties} isNewPlP={isNewPlP} />;
    $[58] = hotelListHeaderProps.sortProperties;
    $[59] = isNewPlP;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== hasMap || $[62] !== isNewPlP || $[63] !== onMapClick) {
    t28 = hasMap && onMapClick && <AnimatedButton isNewPlP={isNewPlP} className={isNewPlP ? "bottom-6" : "bottom-[20px]"} icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} />;
    $[61] = hasMap;
    $[62] = isNewPlP;
    $[63] = onMapClick;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t27 || $[66] !== t28) {
    t29 = <div className="flex flex-row items-center gap-4">{t27}{t28}</div>;
    $[65] = t27;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== t23 || $[69] !== t26 || $[70] !== t29) {
    t30 = <div className={t23}>{t26}{t29}</div>;
    $[68] = t23;
    $[69] = t26;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  const t31 = `${isNewPlP ? "md:block" : ""} p-0`;
  let t32;
  if ($[72] !== bannersProperties?.bannerSlideList || $[73] !== isNewPlP) {
    t32 = !isNewPlP && bannersProperties?.bannerSlideList?.length > 0 && <div className="hidden w-[312px] pb-4 xl:block"><BannerSlide className="p-0" list={bannersProperties?.bannerSlideList} /></div>;
    $[72] = bannersProperties?.bannerSlideList;
    $[73] = isNewPlP;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== citiesFilterProperties || $[76] !== isNewPlP) {
    t33 = <HotelFilter {...citiesFilterProperties} isNewPlP={isNewPlP} />;
    $[75] = citiesFilterProperties;
    $[76] = isNewPlP;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t31 || $[79] !== t32 || $[80] !== t33) {
    t34 = <div className={t31}>{t32}{t33}</div>;
    $[78] = t31;
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  const t35 = `flex min-w-0 shrink grow flex-col ${isNewPlP ? "gap-3" : "gap-5"} lg:gap-4`;
  let t36;
  if ($[82] !== hotelListHeaderProps || $[83] !== isNewPlP) {
    t36 = !isNewPlP && <HotelListHeader {...hotelListHeaderProps} />;
    $[82] = hotelListHeaderProps;
    $[83] = isNewPlP;
    $[84] = t36;
  } else {
    t36 = $[84];
  }
  const t37 = `${isNewPlP ? "-mt-0" : "-mt-5"} bg-on-color-high-emphasis border-outline-thin -mx-4 border-b px-4 lg:m-0 lg:hidden`;
  let t38;
  if ($[85] !== t37 || $[86] !== zinStoryTag) {
    t38 = <HotelShortVideos className={t37} displayType="STORY" displayId={ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />;
    $[85] = t37;
    $[86] = zinStoryTag;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== hotelListHeaderProps.city || $[89] !== hotelListHeaderProps.hasCityNearby || $[90] !== hotelListHeaderProps.sortProperties || $[91] !== hotelPaginationProps || $[92] !== isNewPlP || $[93] !== router) {
    t39 = isNewPlP && <div className="lg:mt-0 lg:hidden"><div className="flex w-full flex-row items-center justify-between gap-4"><div className="min-w-0 flex-1"><HotelCityTitle className="!pt-0" city={hotelListHeaderProps?.city} hasCityPrefix={router.query.locationType !== "category"} loading={hotelPaginationProps.loading} totalItem={hotelPaginationProps.totalCount} /></div><div className="flex shrink-0 flex-row items-center gap-2">{hotelListHeaderProps?.hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch name="nearby" key={`nearby=${router.query?.nearby}`} label={"\u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
            query: deepOmit({
              ...omit(router.query, ["geo_property_summary"]),
              nearby: !router.query?.nearby || undefined
            }, isFilled)
          }, undefined, {
            shallow: true,
            scroll: false
          })} color="secondary" className="!text-body-2 flex flex-row-reverse !items-center !justify-end !whitespace-nowrap !pb-0 lg:!hidden" />}<HotelSortView {...hotelListHeaderProps.sortProperties} buttonProps={{
            "aria-label": "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
            children: undefined,
            className: "!px-0 [&>span:first-child]:!h-9 [&>span:first-child]:!w-9",
            color: router.query.order_by ? "secondary" : "neutral",
            equalDimension: true,
            size: "small",
            StartIcon: <MaterialIcon className="text-[24px] leading-9" name="sort" />,
            variant: "text"
          }} isNewPlP={isNewPlP} /></div></div></div>;
    $[88] = hotelListHeaderProps.city;
    $[89] = hotelListHeaderProps.hasCityNearby;
    $[90] = hotelListHeaderProps.sortProperties;
    $[91] = hotelPaginationProps;
    $[92] = isNewPlP;
    $[93] = router;
    $[94] = t39;
  } else {
    t39 = $[94];
  }
  let t40;
  if ($[95] !== hotelCitiesMainContentProps || $[96] !== isNewPlP || $[97] !== listingContainerProps) {
    t40 = isNewPlP ? <ListingContainer {...listingContainerProps} /> : <HotelCitiesMainContent {...hotelCitiesMainContentProps} />;
    $[95] = hotelCitiesMainContentProps;
    $[96] = isNewPlP;
    $[97] = listingContainerProps;
    $[98] = t40;
  } else {
    t40 = $[98];
  }
  let t41;
  if ($[99] !== hotelPaginationProps || $[100] !== t40) {
    t41 = <div className="relative"><HotelPagination {...hotelPaginationProps}>{t40}</HotelPagination></div>;
    $[99] = hotelPaginationProps;
    $[100] = t40;
    $[101] = t41;
  } else {
    t41 = $[101];
  }
  let t42;
  if ($[102] !== hasMap || $[103] !== isNewPlP || $[104] !== onMapClick) {
    t42 = hasMap && !isNewPlP && <AnimatedButton className="bottom-[20px] self-center md:bottom-6 md:!self-auto xl:!hidden" icon={<MaterialIcon name="map" variant="outlined" />} isNewPlP={isNewPlP} onClick={onMapClick} text={"\u0646\u0645\u0627\u06CC\u0634 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} />;
    $[102] = hasMap;
    $[103] = isNewPlP;
    $[104] = onMapClick;
    $[105] = t42;
  } else {
    t42 = $[105];
  }
  let t43;
  if ($[106] !== t35 || $[107] !== t36 || $[108] !== t38 || $[109] !== t39 || $[110] !== t41 || $[111] !== t42) {
    t43 = <main className={t35}>{t36}{t38}{t39}{t41}{t42}</main>;
    $[106] = t35;
    $[107] = t36;
    $[108] = t38;
    $[109] = t39;
    $[110] = t41;
    $[111] = t42;
    $[112] = t43;
  } else {
    t43 = $[112];
  }
  let t44;
  if ($[113] !== t34 || $[114] !== t43) {
    t44 = <div className="relative flex">{t34}{t43}</div>;
    $[113] = t34;
    $[114] = t43;
    $[115] = t44;
  } else {
    t44 = $[115];
  }
  let t45;
  if ($[116] !== properties.seoData) {
    t45 = <div className="w-full px-6 py-2 xl:mx-auto xl:max-w-[1200px]"><SeoComponents seoData={properties.seoData} linksTitle={"\u0627\u062C\u0627\u0631\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u062F\u0631 \u0634\u0647\u0631\u0647\u0627\u06CC \u067E\u0631\u0637\u0631\u0641\u062F\u0627\u0631"} /></div>;
    $[116] = properties.seoData;
    $[117] = t45;
  } else {
    t45 = $[117];
  }
  let t46;
  if ($[118] !== telesaleProperties) {
    t46 = !isChannel(["b2b", "telesale"]) && <Telesales {...telesaleProperties} />;
    $[118] = telesaleProperties;
    $[119] = t46;
  } else {
    t46 = $[119];
  }
  let t47;
  if ($[120] !== t21 || $[121] !== t22 || $[122] !== t30 || $[123] !== t44 || $[124] !== t45 || $[125] !== t46) {
    t47 = <div className={t21}>{t22}{t30}{t44}{t45}{t46}</div>;
    $[120] = t21;
    $[121] = t22;
    $[122] = t30;
    $[123] = t44;
    $[124] = t45;
    $[125] = t46;
    $[126] = t47;
  } else {
    t47 = $[126];
  }
  let t48;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <Footer />;
    $[127] = t48;
  } else {
    t48 = $[127];
  }
  let t49;
  if ($[128] !== t12 || $[129] !== t13 || $[130] !== t14 || $[131] !== t19 || $[132] !== t20 || $[133] !== t47) {
    t49 = <div className="bg-dim-background">{t12}{t13}{t14}{t15}{t19}{t20}{t47}{t48}</div>;
    $[128] = t12;
    $[129] = t13;
    $[130] = t14;
    $[131] = t19;
    $[132] = t20;
    $[133] = t47;
    $[134] = t49;
  } else {
    t49 = $[134];
  }
  let t50;
  if ($[135] !== t4 || $[136] !== t49 || $[137] !== t9) {
    t50 = <>{t4}{t9}{t49}</>;
    $[135] = t4;
    $[136] = t49;
    $[137] = t9;
    $[138] = t50;
  } else {
    t50 = $[138];
  }
  return t50;
};
const Index: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(3);
  const router = useRouter();
  const hasMounted = useSyncExternalStore(subscribeToClientRender, getClientSnapshot, getServerSnapshot);
  const hasQueryParameters = !isEmpty(omit(router.query, ["locationType", "cityTitle"]));
  if (!properties.locationData) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (hasQueryParameters && !hasMounted) {
    return null;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <CityPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";